document.addEventListener('DOMContentLoaded', function () {
    function getQtyHideButtons() {
      return document.querySelectorAll(
        '.add_to_cart_button[data-qty-hide="true"]'
      );
    }
    async function updateQtyHideButtons() {
      try {
        // Always get the latest cart
        const response = await fetch('/cart.js?_=' + Date.now(), {
          cache: 'no-store'
        });
        const cart = await response.json();
        getQtyHideButtons().forEach(function (button) {
        const productId = String(button.dataset.productId);
          const productExists = cart.items.some(function (item) {
            return String(item.product_id) === productId;
          });
          if (productExists) {
            button.disabled = true;
          } else {
            button.disabled = false;
          }
        });
  
      } catch (error) {
        console.error('Qty hide cart check error:', error);
      }
    }
    // Run on page load
    updateQtyHideButtons();
    document.addEventListener('eurus:cart:items-changed', function () {
      setTimeout(updateQtyHideButtons, 300);
      setTimeout(updateQtyHideButtons, 800);
      setTimeout(updateQtyHideButtons, 1500);
    });
    /*
     * Shopify sections can be re-rendered
     */
    document.addEventListener('shopify:section:load', function () {
      updateQtyHideButtons();
    });
    /*
     * Detect fetch requests to cart endpoints
     * This ensures product removal is detected even
     * if the theme does not dispatch an event.
     */
    const originalFetch = window.fetch;
    window.fetch = async function () {
      const response = await originalFetch.apply(this, arguments);
      const url = arguments[0];
      if (
        typeof url === 'string' &&
        (
          url.includes('/cart/change') ||
          url.includes('/cart/update') ||
          url.includes('/cart/clear') ||
          url.includes('/cart/add')
        )
      ) {
        setTimeout(updateQtyHideButtons, 300);
        setTimeout(updateQtyHideButtons, 800);
      }
      return response;
    };
    /*
     * Fallback:
     * Observe changes to cart drawer
     */
    const observer = new MutationObserver(function () {
      clearTimeout(window.qtyHideCartTimeout);
      window.qtyHideCartTimeout = setTimeout(function () {
        updateQtyHideButtons();
      }, 500);
  
    });
    const cartDrawer = document.querySelector(
      'cart-drawer, #CartDrawer, .cart-drawer'
    );
    if (cartDrawer) {
  
      observer.observe(cartDrawer, {
        childList: true,
        subtree: true
      });
  
    }
  
  });